export default __webpack_public_path__ + "static/media/image-4.2f46ef7e.png";